export const environment = {
  production: true,
  apiUrl: 'https://tools.pack-cup.de/api.php',
};
